<template>
    <div>
        <vue-apex-charts type="bar" height="350" :options="getChartConfig().chartOptions" :series="getChartConfig().series" />
    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';

export default {
    props: ['reportData'],
    data() {
        return {
            reportBar: {
                // series: [{
                //     name: 'Users',
                //     data: [75, 125, 225, 175, 125]
                // }],
                chartOptions: {
                    grid: {
                        show: false,
                        padding: {
                            left: 0,
                            right: 0
                        }
                    },
                    chart: {
                        type: 'bar',
                        sparkline: { enabled: false },
                        toolbar: { show: false },
                        height: 1000
                    },
                    states: {
                        hover: {
                            filter: 'none'
                        }
                    },
                    // colors: ['#7367f0'],
                    plotOptions: {
                        bar: {
                            columnWidth: '45%',
                            distributed: true,
                            endingShape: 'rounded', // Deprecated
                            // borderRadius: '20px', // Coming Soon
                            horizontal: true
                        }
                    },
                    tooltip: {
                        x: { show: false }
                    },
                    dataLabels: {
                        enabled: false
                    },
                    xaxis: {
                        categories: []
                    }
                }
            },
        }
    },
    components: { VueApexCharts },
    computed: {
        orgData() {
            return this.$store.state.organization.orgData;
        },
    },
    methods: {
        getChartConfig() {
            let seriesData = Object.values(this.reportData.count);
            let xaxisCategories = Object.keys(this.reportData.count);
            this.reportBar.series = [{
                name: 'Users',
                data: seriesData
            }];
            this.reportBar.chartOptions.xaxis.categories = xaxisCategories;
            this.reportBar.chartOptions.colors = [this.orgData.primaryThemeColor];

            return this.reportBar;
        },
    }
}
</script>